import React from "react"
import ExtrasAndContradictionsStructure from "components/ExtrasAndContradictions/ExtrasAndContradictionsStructure"
import { Helmet } from "react-helmet-async"
import { Container } from "reactstrap"
import EntitlementPageGuard from "components/Subscription/EntitlementPageGuard"
import { EXTRAS } from "constants/entitlements"

const ExtrasAndContradictionsIndex = () => {
  return (
    <EntitlementPageGuard permission={EXTRAS}>
      <div className="page-content">
        <Helmet>
          <title>Planhopper | Proyecto </title>
        </Helmet>
        <Container fluid>
          <ExtrasAndContradictionsStructure />
        </Container>
      </div>
    </EntitlementPageGuard>
  )
}

export default ExtrasAndContradictionsIndex
